export default "__VITE_ASSET__96839024__"